import { render, staticRenderFns } from "./GgtGeGu.vue?vue&type=template&id=1abdb8a4"
import script from "./GgtGeGu.vue?vue&type=script&lang=js"
export * from "./GgtGeGu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports